exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".more-actions {\n  font-size: 1.2rem;\n}\n", "", {"version":3,"sources":["/home/vsts/work/1/s/apps/client/landing/src/molecules/components/MoreActions.vue"],"names":[],"mappings":"AAOA;EACI,kBAAiB;CAAA","file":"MoreActions.vue?vue&type=style&index=0&id=0094dc42&lang=css&","sourcesContent":["@import \"../../../../common/styles/user-variables\";\n@import \"../../../../vendor/createx/styles/helpers\";\n@import \"~bootstrap/scss/functions\";\n@import \"~bootstrap/scss/variables\";\n@import \"~bootstrap/scss/mixins\";\n\n\n.more-actions {\n    font-size: 1.2rem;\n}\n"],"sourceRoot":""}]);

// exports
